<template>
  <div class="form-page-container">
    <PremiumPage
      title="Edit Bill Master"
      subtitle="Update bill template and visibility settings"
      showBack
      show-footer-buttons
      submit-label="Submit"
      :loading="loading"
      @cancel="$router.go(-1)"
      @submit="saveBillDetails"
    >
      <div class="pa-4">
        <v-form>
          <div class="half-width-wrap">
            <!-- ── Schedule (Read Only in Edit) & Target Audience ── -->
            <!-- <v-row>
              <v-col cols="12">
                <div class="premium-field-label mb-3">Target Audience</div>
                <div class="radio-row mb-3">
                  <template v-if="societyUnitType == 3">
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'all' }"
                    >
                      <input type="radio" value="all" v-model="sendto" hidden />
                      <v-icon small class="mr-1"
                        >mdi-account-group-outline</v-icon
                      >
                      All Units
                    </label>
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'houses' }"
                    >
                      <input
                        type="radio"
                        value="houses"
                        v-model="sendto"
                        hidden
                      />
                      <v-icon small class="mr-1">mdi-home-outline</v-icon>
                      All Houses
                    </label>
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'shops' }"
                    >
                      <input
                        type="radio"
                        value="shops"
                        v-model="sendto"
                        hidden
                      />
                      <v-icon small class="mr-1">mdi-store-outline</v-icon>
                      All Shops
                    </label>
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'selected' }"
                    >
                      <input
                        type="radio"
                        value="selected"
                        v-model="sendto"
                        hidden
                      />
                      <v-icon small class="mr-1"
                        >mdi-cursor-default-click-outline</v-icon
                      >
                      Specific Units
                    </label>
                  </template>
                  <template v-else>
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'all' }"
                    >
                      <input type="radio" value="all" v-model="sendto" hidden />
                      <v-icon small class="mr-1"
                        >mdi-account-group-outline</v-icon
                      >
                      All Units
                    </label>
                    <label
                      class="radio-option"
                      :class="{ active: sendto === 'selected' }"
                    >
                      <input
                        type="radio"
                        value="selected"
                        v-model="sendto"
                        hidden
                      />
                      <v-icon small class="mr-1"
                        >mdi-cursor-default-click-outline</v-icon
                      >
                      Selected Units
                    </label>
                  </template>
                </div>
              </v-col>
            </v-row> -->

            <!-- <v-expand-transition>
              <div
                v-if="sendto === 'selected'"
                class="selective-selectors mb-6"
              >
                <template v-if="societyUnitType == 3">
                  <v-row dense>
                    <v-col cols="12" v-if="useBlocks">
                      <div class="premium-field-label mb-2">
                        Filter Houses by Block
                      </div>
                      <v-select
                        v-model="houseBlock"
                        :items="flats"
                        item-text="name"
                        item-value="id"
                        placeholder="Select Block"
                        outlined
                        dense
                        hide-details="auto"
                        class="premium-select"
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <v-row dense class="mt-2">
                    <v-col cols="12">
                      <div class="premium-field-label mb-2">Select Houses</div>
                      <v-select
                        v-model="selectedHouses"
                        :items="houseList"
                        item-text="display_number"
                        item-value="id"
                        multiple
                        chips
                        dense
                        deletable-chips
                        outlined
                        hide-details="auto"
                        class="premium-select"
                        placeholder="Choose Houses"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @click="toggleAllHouses">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  selectedHouses.length > 0 ? 'primary' : ''
                                "
                                >{{ iconHousesSel }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <div class="premium-field-label mb-2">Select Shops</div>
                      <v-select
                        v-model="selectedShops"
                        :items="shopList"
                        item-text="display_number"
                        item-value="id"
                        multiple
                        chips
                        dense
                        deletable-chips
                        outlined
                        hide-details="auto"
                        class="premium-select"
                        placeholder="Choose Shops"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @click="toggleAllShops">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  selectedShops.length > 0 ? 'primary' : ''
                                "
                                >{{ iconShopsSel }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-row dense>
                    <v-col cols="12" v-if="useBlocks">
                      <div class="premium-field-label mb-2">
                        Filter Units by Block
                      </div>
                      <v-select
                        v-model="bill.flat_id"
                        :items="flats"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        hide-details="auto"
                        class="premium-select"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12">
                      <div class="premium-field-label mb-2">Select Units</div>
                      <v-select
                        v-model="bill.members"
                        :items="houses"
                        item-text="display_number"
                        item-value="id"
                        multiple
                        chips
                        dense
                        deletable-chips
                        outlined
                        hide-details="auto"
                        class="premium-select"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @click="toggleHouses">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  bill.members.length > 0 ? 'primary' : ''
                                "
                                >{{ iconHouses }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </v-expand-transition> -->

            <!-- <v-divider class="my-8" /> -->

            <v-row>
              <v-col cols="12">
                <PremiumInput
                  v-model="bill.title"
                  label="Bill Title"
                  placeholder="e.g. Monthly Maintenance Jan 2024"
                  icon="mdi-format-title"
                  v-validate="'required'"
                  name="title"
                  :error="errors.first('title') || serverSideErrors.title"
                />
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="12">
                <PremiumInput
                  v-model="bill.description"
                  label="Description"
                  placeholder="Brief summary of charges..."
                  multiline
                  rows="3"
                  resizable
                  v-validate="'required'"
                  name="description"
                  :error="errors.first('description') || serverSideErrors.description"
                />
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="12">
                <PremiumInput
                  v-model="bill.amount"
                  label="Amount for Owners (₹)"
                  placeholder="0.00"
                  icon="mdi-currency-inr"
                  v-validate="'required|numeric|max_value:9999999'"
                  name="amount"
                  type="number"
                  :error="errors.first('amount') || serverSideErrors.amount"
                />
              </v-col>
              <v-col cols="12">
                <PremiumInput
                  v-model="bill.amount_for_rental"
                  label="Amount for Tenants (₹)"
                  placeholder="0.00"
                  icon="mdi-currency-inr"
                  v-validate="'numeric|max_value:9999999'"
                  name="amount_for_rental"
                  type="number"
                  :error="
                    errors.first('amount_for_rental') ||
                    serverSideErrors.amount_for_rental
                  "
                />
              </v-col>
              <v-col cols="12">
                <PremiumInput
                  v-model="bill.late_fee_amount"
                  label="Late Fee Amount (₹)"
                  placeholder="0.00"
                  icon="mdi-currency-inr"
                  v-validate="`required|numeric|min_value:0|max_value:${bill.amount || 9999999}`"
                  name="late fee amount"
                  type="number"
                  :error="errors.first('late fee amount')"
                />
              </v-col>
              <!-- <v-col cols="12">
                <div class="premium-field-label mb-3">Bill Schedule</div>
                <div class="radio-row muted-selection">
                  <label
                    v-for="t in types"
                    :key="t.value"
                    class="radio-option"
                    :class="{ active: bill.type === t.value }"
                    style="cursor: default; opacity: 0.8"
                  >
                    <v-icon small class="mr-2">{{ t.icon }}</v-icon>
                    {{ t.text }}
                  </label>
                </div>
              </v-col> -->
            </v-row>

            <!-- ── Attachments ── -->
            <v-row class="mt-8">
              <v-col cols="12">
                <div class="premium-field-label mb-4">
                  Sample Invoices / Documents
                </div>

                <div
                  class="doc-grid mb-6"
                  v-if="bill.documents && bill.documents.length > 0"
                >
                  <div
                    v-for="(item, idx) in bill.documents"
                    :key="item.id"
                    class="doc-card"
                  >
                    <img
                      v-if="item.file_type == 'image'"
                      :src="base_url + '/uploads/' + item.document_url"
                      class="doc-card-img"
                    />
                    <div v-else class="doc-card-placeholder">
                      <v-icon size="48" color="#EF4444">mdi-file-pdf-box</v-icon>
                      <span class="doc-card-placeholder-label">PDF</span>
                    </div>
                    <div class="doc-card-overlay">
                      <button type="button" class="doc-overlay-btn" @click.stop="openDocument(idx)">
                        <v-icon size="16" color="white">mdi-eye-outline</v-icon>
                      </button>
                      <button type="button" class="doc-overlay-btn danger" @click.stop="confirmDelete(item.id)">
                        <v-icon size="16" color="white">mdi-delete-outline</v-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="no-docs-banner mb-6">
                  <v-icon color="#CBD5E1" class="mr-2">mdi-file-hidden</v-icon>
                  <span>No existing documents attached</span>
                </div>

                <input
                  type="file"
                  ref="attachInput"
                  multiple
                  accept="image/*,.pdf"
                  hidden
                  @change="onAttachChange"
                />
                <!-- Drop Zone -->
                <div
                  class="attach-dropzone"
                  :class="{ 'attach-dropzone-active': dragging }"
                  @click="$refs.attachInput.click()"
                  @dragover.prevent="dragging = true"
                  @dragleave="dragging = false"
                  @drop.prevent="onDrop"
                >
                  <v-icon size="28" color="var(--tx3)">mdi-paperclip</v-icon>
                  <div class="dropzone-label">
                    Click or drag files here to upload new
                  </div>
                  <div class="dropzone-hint">JPG, PNG, PDF allowed</div>
                </div>

                <!-- Server-side file upload error -->
                <div v-if="getServerError('documents')" class="server-error mt-2">
                  {{ getServerError('documents') }}
                </div>

                <!-- Preview Grid -->
                <div
                  v-if="attachPreviews.length"
                  class="attach-preview-grid mt-3"
                >
                  <div
                    v-for="(p, i) in attachPreviews"
                    :key="i"
                    class="attach-preview-item"
                  >
                    <img
                      v-if="p.isImage"
                      :src="p.url"
                      class="attach-preview-img"
                    />
                    <div v-else class="attach-preview-pdf">
                      <v-icon size="32" color="#EF4444"
                        >mdi-file-pdf-box</v-icon
                      >
                      <span class="attach-preview-name">{{ p.name }}</span>
                    </div>
                    <button
                      type="button"
                      class="attach-remove-btn"
                      @click.stop="removeAttach(i)"
                    >
                      <v-icon size="14" color="white">mdi-close</v-icon>
                    </button>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </div>
    </PremiumPage>

    <!-- Use shared ConfirmModal for delete confirmation -->
    <ConfirmModal
      v-model="deleteDialog"
      type="danger"
      title="Delete Document"
      message="Are you sure you want to delete this attachment?"
      @confirm="deleteDocument(delete_id)"
    />

    <!-- ── Media Viewer ── -->
    <MediaViewer
      v-model="imageDialog"
      :items="mediaItems"
      :index="mediaIndex"
    />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import PremiumPage from "../../common/PremiumPage.vue";
import PremiumInput from "../../common/PremiumInput.vue";
import MediaViewer from "../../common/MediaViewer.vue";
import ConfirmModal from "../../common/ConfirmModal.vue";

export default {
  name: "EditBill",
  components: { PremiumPage, PremiumInput, MediaViewer, ConfirmModal },
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      bill: {
        title: "",
        description: "",
        amount: "",
        amount_for_rental: "",
        late_fee_amount:0,
        documents: [],
        flat_id: null,
        members: [],
        type: 1,
      },
      sendto: "all",
      houseBlock: null,
      selectedHouses: [],
      selectedShops: [],
      flats: [],
      houses: [],
      houseList: [],
      shopList: [],
      documents: [],
      menu: false,
      attachPreviews: [],
      dragging: false,
      deleteDialog: false,
      delete_id: null,
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      mediaIndex: 0,
      types: [
        { text: "One Time", value: 1, icon: "mdi-calendar-check-outline" },
        { text: "Monthly", value: 2, icon: "mdi-calendar-month-outline" },
        { text: "Yearly", value: 3, icon: "mdi-calendar-sync-outline" },
      ],
    };
  },
  computed: {
    ...mapGetters("society", ["useBlocks", "unitType"]),
    societyUnitType() {
      return this.unitType;
    },
    mediaItems() {
      return (this.bill.documents || []).map((doc) => ({
        url: this.base_url + "/uploads/" + doc.document_url,
        type: doc.file_type === "image" ? "image" : "document",
        name: doc.document_url ? doc.document_url.split("/").pop() : "file",
      }));
    },
    allHousesSelected() {
      return (
        this.bill.members.length > 0 &&
        this.bill.members.length === this.houses.length
      );
    },
    iconHouses() {
      return this.allHousesSelected
        ? "mdi-close-box"
        : this.bill.members.length > 0
        ? "mdi-minus-box"
        : "mdi-checkbox-blank-outline";
    },
    allHousesSelMixed() {
      return (
        this.houseList.length > 0 &&
        this.selectedHouses.length === this.houseList.length
      );
    },
    iconHousesSel() {
      return this.allHousesSelMixed
        ? "mdi-close-box"
        : this.selectedHouses.length > 0
        ? "mdi-minus-box"
        : "mdi-checkbox-blank-outline";
    },
    allShopsSel() {
      return (
        this.shopList.length > 0 &&
        this.selectedShops.length === this.shopList.length
      );
    },
    iconShopsSel() {
      return this.allShopsSel
        ? "mdi-close-box"
        : this.selectedShops.length > 0
        ? "mdi-minus-box"
        : "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    sendto() {
      if (this.sendto === "selected") {
        if (this.societyUnitType == 3) this.loadMixedUnits();
        else if (!this.useBlocks) this.getHouses();
      }
    },
    "bill.flat_id"() {
      if (this.sendto === "selected" && this.societyUnitType != 3)
        this.getHouses();
    },
    houseBlock() {
      if (this.houseBlock) this.loadHouseList();
      else this.loadMixedUnits();
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getServerError(fieldBase) {
      if (!this.serverSideErrors) return null;
      // direct match
      if (this.serverSideErrors[fieldBase]) return this.serverSideErrors[fieldBase];
      // try common variants (documents[], documents.0, document)
      const keys = Object.keys(this.serverSideErrors || {});
      for (let k of keys) {
        if (k && k.toLowerCase().includes(fieldBase.toLowerCase())) {
          return this.serverSideErrors[k];
        }
      }
      return null;
    },
    filterActiveDocuments(docs) {
      return (docs || []).filter((doc) => !doc.deleted);
    },
    toggleHouses() {
      const currentIds = this.houses.map((h) => h.id);
      if (currentIds.every((id) => this.bill.members.includes(id)))
        this.bill.members = this.bill.members.filter(
          (id) => !currentIds.includes(id),
        );
      else
        this.bill.members = [...new Set([...this.bill.members, ...currentIds])];
    },
    toggleAllHouses() {
      const currentIds = this.houseList.map((h) => h.id);
      if (currentIds.every((id) => this.selectedHouses.includes(id)))
        this.selectedHouses = this.selectedHouses.filter(
          (id) => !currentIds.includes(id),
        );
      else
        this.selectedHouses = [
          ...new Set([...this.selectedHouses, ...currentIds]),
        ];
    },
    toggleAllShops() {
      const currentIds = this.shopList.map((h) => h.id);
      if (currentIds.every((id) => this.selectedShops.includes(id)))
        this.selectedShops = this.selectedShops.filter(
          (id) => !currentIds.includes(id),
        );
      else
        this.selectedShops = [
          ...new Set([...this.selectedShops, ...currentIds]),
        ];
    },
    getFlats() {
      this.$axios.get(`/societyadmin/flats`).then((r) => {
        if (r.data.status) this.flats = r.data.flats;
      });
    },
    getHouses() {
      this.$axios
        .get(`/societyadmin/houses`, { params: { flat_id: this.bill.flat_id } })
        .then((r) => {
          if (r.data.status)
            this.houses = r.data.houses.map((h) => this.formatUnit(h));
        });
    },
    loadMixedUnits() {
      this.$axios.get(`/societyadmin/houses`).then((r) => {
        if (r.data.status) {
          const all = r.data.houses.map((h) => this.formatUnit(h));
          this.houseList = all.filter((h) => h.unit_type != 2);
          this.shopList = all.filter((h) => h.unit_type == 2);
        }
      });
    },
    loadHouseList() {
      this.$axios
        .get(`/societyadmin/houses`, { params: { flat_id: this.houseBlock } })
        .then((r) => {
          if (r.data.status)
            this.houseList = r.data.houses
              .map((h) => this.formatUnit(h))
              .filter((h) => h.unit_type != 2);
        });
    },
    formatUnit(h) {
      let disp = h.flat ? h.flat.name + " - " : "";
      if (this.societyUnitType == 3)
        disp += h.unit_type == 2 ? "Shop " : "House ";
      disp += h.house_number;
      return { ...h, display_number: disp };
    },
    buildSendToValue() {
      if (this.sendto === "houses") return "4";
      if (this.sendto === "shops") return "5";
      if (this.sendto === "selected") return "3";
      return "1";
    },
    parseSendTo(val) {
      const n = Number(val);
      if (n === 1) return "all";
      if (n === 4) return "houses";
      if (n === 5) return "shops";
      if (n === 3) return "selected";
      return "all";
    },
    onAttachChange(e) {
      this.addFiles(Array.from(e.target.files));
      e.target.value = "";
    },
    onDrop(e) {
      this.dragging = false;
      this.addFiles(Array.from(e.dataTransfer.files));
    },
    addFiles(files) {
      files.forEach((file) => {
        this.documents.push(file);
        const isImage = file.type.startsWith("image/");
        if (isImage) {
          const url = URL.createObjectURL(file);
          this.attachPreviews.push({ url, name: file.name, isImage: true });
        } else {
          this.attachPreviews.push({
            url: null,
            name: file.name,
            isImage: false,
          });
        }
      });
    },
    removeAttach(i) {
      this.documents.splice(i, 1);
      this.attachPreviews.splice(i, 1);
    },
    saveBillDetails() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;
        this.loading = true;
        const formData = new FormData();
        formData.append("title", this.bill.title);
        formData.append("description", this.bill.description);
        formData.append("amount", this.bill.amount);
        formData.append("amount_for_rental", this.bill.amount_for_rental || "");
        formData.append("late_fee_amount", this.bill.late_fee_amount || 0);

        // formData.append("send_to", this.buildSendToValue());
        // formData.append("flat_id", this.bill.flat_id || "");

        let members =
          this.sendto === "selected"
            ? this.societyUnitType == 3
              ? [...this.selectedHouses, ...this.selectedShops]
              : this.bill.members
            : [];
        members.forEach((m) => formData.append("members[]", m));
        this.documents.forEach((d) => formData.append("documents[]", d));

        this.$axios
          .put("/societyadmin/bills/" + this.bill.id, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.loading = false;
            if (response.data.status) {
              this.setAlert({
                showAlert: true,
                message: response.data.message,
                variant: "green accent-4",
                timeout: 2000,
              });
              this.$router.push({ path: "/societyadmin/bills" });
            } else {
              this.serverSideErrors = {};
              if (response.data.errors)
                response.data.errors.forEach((e) => {
                  this.serverSideErrors[e.field] = e.message;
                });
              else this.showErr(response.data.message);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    getBillDetail() {
      this.$axios
        .get("societyadmin/bills/" + this.$route.params.id)
        .then((response) => {
          const data = response.data;
          if (data.status) {
            const mbrs = data.bill.members || [];
            this.bill = {
              ...data.bill,
              members: mbrs.map((m) => m.id),
              documents: this.filterActiveDocuments(data.bill.documents || []),
            };
            this.sendto = this.parseSendTo(data.bill.send_to);
            if (this.societyUnitType == 3 && this.sendto === "selected") {
              this.selectedHouses = mbrs
                .filter((m) => m.unit_type != 2)
                .map((m) => m.id);
              this.selectedShops = mbrs
                .filter((m) => m.unit_type == 2)
                .map((m) => m.id);
            }
          }
        });
    },
    confirmDelete(id) {
      this.deleteDialog = true;
      this.delete_id = id;
    },
    deleteDocument(id) {
      this.$axios
        .delete(`societyadmin/bills/${this.$route.params.id}/documents/${id}`)
        .then((r) => {
          if (r.data.status) {
            this.bill.documents = (this.bill.documents || []).filter(
              (doc) => doc.id !== id,
            );
            if (this.mediaIndex >= this.bill.documents.length) {
              this.mediaIndex = Math.max(0, this.bill.documents.length - 1);
            }
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: r.data.message,
            });
          } else this.showErr(r.data.message);
        });
    },
    openDocument(idx) {
      this.mediaIndex = idx;
      this.imageDialog = true;
    },
    showErr(msg) {
      this.setAlert({
        showAlert: true,
        message: msg,
        variant: "red accent-3",
        timeout: 2000,
      });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getFlats();
    this.getBillDetail();
  },
};
</script>

<style scoped>
.form-page-container {
  padding: 24px;
}

/* ── 50% width wrapper ── */
.half-width-wrap {
  max-width: 50%;
}
@media (max-width: 960px) {
  .half-width-wrap {
    max-width: 100%;
  }
}

.premium-field-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--tx3, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ── Radio Controls ── */
.radio-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--surface2);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--tx2);
  cursor: pointer;
  transition: all 0.2s;
}
.radio-option:hover {
  border-color: var(--brand);
  transform: translateY(-1px);
}
.radio-option.active {
  border-color: var(--brand);
  background: var(--brand-light, rgba(16, 185, 129, 0.08));
  color: var(--brand);
}

/* ── Custom UI ── */
::v-deep .premium-textarea .v-input__slot,
::v-deep .premium-select .v-input__slot {
  border-radius: 12px !important;
  background: var(--surface2) !important;
  border: 1px solid var(--border) !important;
}
::v-deep .premium-textarea fieldset,
::v-deep .premium-select fieldset {
  border: none;
}

/* ── Attachment Grid ── */
.attachment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
}
.attachment-card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--border);
  transition: all 0.2s;
}
.file-preview-wrap {
  position: relative;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface2);
}
.preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.preview-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.file-type {
  font-size: 11px;
  font-weight: 800;
  color: var(--tx3);
}

.file-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s;
}
.file-preview-wrap:hover .file-overlay {
  opacity: 1;
}
.overlay-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(4px);
}

.no-docs-banner {
  display: flex;
  align-items: center;
  padding: 20px;
  background: var(--surface2);
  border: 1.5px dashed var(--border);
  border-radius: 12px;
  color: var(--tx3);
  font-size: 13px;
  font-weight: 500;
}

/* ── Attachment Uploader ── */
.attach-dropzone {
  border: 2px dashed var(--border, #e2e8f0);
  border-radius: 14px;
  background: var(--surface2, #f8fafc);
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}
.attach-dropzone:hover {
  border-color: var(--brand);
  background: rgba(13, 153, 114, 0.04);
}
.attach-dropzone-active {
  border-color: var(--brand) !important;
  background: rgba(13, 153, 114, 0.06) !important;
}
.dropzone-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--tx2);
  margin-top: 4px;
}
.dropzone-hint {
  font-size: 11.5px;
  color: var(--tx3);
  font-weight: 500;
}

.attach-preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.attach-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--surface2);
}
.attach-preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.attach-preview-pdf {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
}
.attach-preview-name {
  font-size: 9px;
  color: var(--tx3);
  text-align: center;
  word-break: break-all;
  line-height: 1.2;
}
.attach-remove-btn {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.attach-remove-btn:hover {
  background: #ef4444;
}

.server-error {
  color: #ef4444;
  font-size: 12px;
  margin-left: 6px;
}

::v-deep .premium-file-input .v-input__slot {
  border-radius: 12px !important;
  background: var(--surface2) !important;
  border: 2px dashed var(--border) !important;
}
::v-deep .premium-file-input fieldset {
  border: none;
}

.cancel-btn {
  color: var(--tx2);
  font-weight: 600;
  text-transform: none;
}
.save-btn {
  border-radius: 12px !important;
  font-weight: 800;
  height: 46px !important;
  text-transform: none !important;
}
.delete-dialog-content {
  border-radius: 24px;
}
</style>
